import NoDataCard from './NoDataCard';

export type { NoDataCardProps } from './NoDataCard';

export default NoDataCard;
